import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import cx from 'clsx';

import { IMessageToolCall } from '../../../../../api/types';

import { BigQueryToolCall } from './BigQueryToolCall/BigQueryToolCall';
import { BIGQUERY_TOOL_CALL_NAME } from './BigQueryToolCall/consts';
import { INTERNAL_SEARCH_TOOL_CALL_NAME } from './InternalSearchToolCall/consts';
import { InternalSearchToolCall } from './InternalSearchToolCall/InternalSearchToolCall';
import { UnknownToolCall } from './UnknownToolCall/UnknownToolCall';

import styles from './AssistantToolCall.module.scss';

interface AssistantToolCallProps {
    toolCall: IMessageToolCall;
}

export const AssistantToolCall: FC<AssistantToolCallProps> = ({ toolCall }) => {
    // Default case - try to handle unknown tool calls
    let toolCallElement = <UnknownToolCall toolCall={toolCall} />;

    if (toolCall.function_name === INTERNAL_SEARCH_TOOL_CALL_NAME) {
        toolCallElement = <InternalSearchToolCall toolCall={toolCall} />;
    } else if (toolCall.function_name === BIGQUERY_TOOL_CALL_NAME) {
        toolCallElement = <BigQueryToolCall toolCall={toolCall} />;
    }

    return (
        <Box
            className={cx(styles.toolCall, {
                [styles.failed]: toolCall.tool_call_succeeded === false,
            })}
        >
            {toolCallElement}
            {toolCall.tool_call_succeeded === false && <div className={cx(styles.wrapper)}>!</div>}
        </Box>
    );
};
